<div class="overlap_panel_wrapper">
  <div class="overlap_panel_sidebar">
    <div class="side_header">
      <div class="cross_wrap">
        <a href="javascript:void(0);" (click)="close()">
          <img src="../../../../assets/img/cross_icon.svg" alt="" class="icon">
        </a>
      </div>
      <p class="company_name">Purchase Order</p>
      <div class="back_wrap">
        @if (stepper.selectedIndex > 0) {
          <a (click)="goBack(stepper)" class="back-button">
            <img src="../../../../assets/img/left_orange_arrow.svg" alt="Back" class="arrow">
            <span>Back</span>
          </a>
        }
      </div>
    </div>
  </div>
  <div class="overlap_right_panel">
    <form [formGroup]="poForm" novalidate>
      <mat-horizontal-stepper #stepper [linear]="true" (selectionChange)="onStepChanged($event, stepper)">
        <mat-step >
          <ng-template matStepLabel>Add Purchase Order</ng-template>
          <app-add-purchase-order-details [addPurchaseOrderObject]="addPurchaseOrderObject"></app-add-purchase-order-details>
          <div class="controls">
            <button type="button" mat-button class="btn_transparent" (click)="close()">Cancel</button>
            <button mat-button matStepperNext class="btn_solid_color"
                    [disabled]="(addPurchaseOrderObject.selectedType !== 'vendor' && !addPurchaseOrderObject.jobId) ||
                               (addPurchaseOrderObject.selectedType === 'vendor' && !addPurchaseOrderObject.vendorId)" >
              Next <img src="../../../../assets/img/btn_arrow.png" alt="icon" class="icon">
            </button>
          </div>
        </mat-step>
        <mat-step   >
          <ng-template matStepLabel>Add Purchase Order</ng-template>
          <app-add-purchase-order-preview  [addPurchaseOrderObject]="addPurchaseOrderObject"></app-add-purchase-order-preview>
          <div class="controls">
            <button mat-button matStepperPrevious class="btn_transparent">Back</button>
            <button mat-button
                    [disabled]="(addPurchaseOrderObject.selectedType !== 'vendor' && !addPurchaseOrderObject.jobId) ||
                               (addPurchaseOrderObject.selectedType === 'vendor' && !addPurchaseOrderObject.vendorId)"
              class="btn_solid_color"
            (click)="save()">Save</button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </form>
  </div>
</div>